module.exports = __webpack_public_path__ + "img/preview_contact.ef41b131.png";